import { Switch, Text, Image, useMantineTheme } from "@mantine/core";
import NextImage from "next/image";
import QuickBooksLogo from "@/app/_media/quickbooks.svg";
import { IconX } from "@tabler/icons-react";
import useDeviceType from "@/app/_hooks/useDeviceType";

interface QBSyncSwitchProps {
  isVisible: boolean;
  inputProps: any;
  checked: boolean;
  disabled?: boolean;
}

const QBSyncSwitch = ({
  isVisible,
  checked,
  inputProps,
  disabled = false,
}: QBSyncSwitchProps) => {
  const theme = useMantineTheme();
  const { isMobile } = useDeviceType();
  if (!isVisible) return null;

  return (
    <Switch
      disabled={disabled}
      label={
        !isMobile ? (
          <Text size="sm" c={checked ? "var(--mantine-color-text)" : "dimmed"}>
            Sync to QuickBooks
          </Text>
        ) : null
      }
      labelPosition="left"
      color="gray"
      size="md"
      styles={{
        labelWrapper: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },

        thumb: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: checked ? "#2CA01D" : theme.colors.red[5],
          borderColor: checked ? "#2CA01D" : theme.colors.red[5],
          borderRadius: "50%",
        },
      }}
      thumbIcon={
        checked ? (
          <Image
            style={{
              borderRadius: "50%",
            }}
            component={NextImage}
            src={QuickBooksLogo}
            h={18}
            w={18}
            alt="QuickBooks"
          />
        ) : (
          <IconX
            style={{ width: 12, height: 12 }}
            color={theme.white}
            stroke={3}
          />
        )
      }
      checked={checked}
      {...inputProps}
    />
  );
};

export default QBSyncSwitch;
